<template>
  <div class="download-item" v-view="{spm:'1003.2449.3001.7927', dest:dateObject.sourceUrl,index}">
    <!-- 左侧文件缩略展示 -->
    <div class="file">
      <img src="@/assets/imgs/fileborder.png" alt />
      <div class="range">
        <img class="block" :src="dateObject.thumbnail" alt />
      </div>
      <img class="file-icon" :src="dateObject.fileIcon" alt />
    </div>
    <!-- 右侧描述信息 -->
    <div class="description">
      <a
        v-spm="{spm:'1003.2449.3001.7924', dest:dateObject.sourceUrl,index}"
        class="des module-click"
        :href="dateObject.sourceUrl"
        target="_blank"
      >
        <h1 class="module-title module-click rowspan">{{dateObject.title}}</h1>
      </a>
      <p class="module-des row-des-download">{{dateObject.description}}</p>
      <!-- 标签列表 -->
      <div class="other">
        <div class="leftx">
          <ul class="module-tag">
            <a
              :href="item.tagUrl"
              v-for="item in dateObject.tagList"
              :key="item.id"
              target="_blank"
            >
              <li>{{item.tagName}}</li>
            </a>
          </ul>
          <span class="module-text margin-right-12">下载时间{{dateObject.dateline}}</span>
          <span
            class="module-text margin-right-12"
            style="text-transform : uppercase"
          >{{dateObject.fileType}}</span>
          <span class="module-text">{{dateObject.sourceSize | fileSize}}</span>
        </div>
        <!-- 评论按钮与点击埋点 -->
        <a :href="dateObject.sourceUrl+'#comment'" v-query="'1003.2449.3001.7924'" target="_blank">
          <div class="rightx">
            <img class="before" src="@/assets/imgs/comment.png" alt />
            <img class="after" src="@/assets/imgs/commentafter.png" alt />
            <span>评论</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dateObject: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  filters: {
    // 文件大小进制转化
    fileSize(size) {
      let temp = size / 1024;

      if (temp >= 1024) {
        return Math.floor(temp / 1024) + "MB";
      } else if (temp >= 1) {
        return Math.floor(temp) + "KB";
      } else {
        return Math.floor(temp / 1024 / 1024) + "GB";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.download-item {
  margin-bottom: 16px;
  width: 100%;
  height: 134px;
  display: flex;
  justify-content: space-between;

  .file {
    position: relative;
    width: 100px;
    height: 134px;

    img {
      position: absolute;
      z-index: 0;
      width: 100px;
      height: 134px;
      object-fit: cover;
    }

    .range {
      position: absolute;
      z-index: 1;
      margin: 14px 8px 7px 8px;
      width: 82px;
      height: 111px;
      background: #ffffff;
      border-radius: 1px;
      border: 1px solid #f7f7fc;

      .block {
        margin: 14px 0;
        width: 82px;
        height: 83px;
        object-fit: cover;
      }
    }

    .file-icon {
      position: absolute;
      right: 4px;
      bottom: 5px;
      z-index: 2;
      width: 24px;
      height: 24px;
      object-fit: cover;
    }
  }

  .description {
    padding: 12px 0;
    width: calc(~"100% - 112px");

    .row-des-download {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
    }

    @media screen and (max-width: 1440px) {
      .row-des-download {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .other {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .leftx {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      .rightx {
        display: flex;
        align-items: center;
        width: 60px;
        cursor: pointer;

        img {
          margin-right: 4px;
          display: block;
          width: 24px;
          height: 24px;
          object-fit: cover;
        }

        .before {
          display: flex;
        }

        .after {
          display: none;
        }

        span {
          font-size: 14px;
          font-weight: 400;
          color: #222226;
          line-height: 24px;
          user-select: none;
        }
      }

      .rightx:hover {
        .before {
          display: none;
        }

        .after {
          display: flex;
        }

        span {
          font-size: 14px;
          font-weight: 400;
          color: #999aaa;
          line-height: 24px;
          user-select: none;
        }
      }
    }

    @media screen and (max-width: 1440px) {
      .other {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }
    }
  }
}
</style>